export class SkipRepayType{
skipTypcode: String;
portfolioId: number
}